<template>
    <van-popup v-model:show="show" position="center" :overlay-style="{ overflow: 'hidden' }" :style="{
        width: '100%',
        height: '100vh',
        color: '#fff',
        background: 'transparent',
        display:'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: '10001'
    }">
        <div class="popupContainer">
            <div class="collect_Container">
                <img src="@/assets/collect/rainv2_bg1.png" alt="" @click="handleClick">
                <van-row class="row_section">
                    <van-col class="point_star" span="4">
                        <img src="@/assets/collect/rainv2_star.png" alt="">
                    </van-col>
                    <van-col class="point_text" span="20">
                        {{ $t('collect.rechargedMembers') }}
                    </van-col>

                    <van-col class="point_star" span="4">
                        <img src="@/assets/collect/rainv2_star.png" alt="">
                    </van-col>
                    <van-col class="point_text" span="20">
                        {{ $t('collect.maximumCachValue') }} R$7.777.
                    </van-col>
                </van-row>
                <div class="close_button">
                    <img src="@/assets/collect/rainv2_close.png" alt="" @click="close">
                </div>
            </div>
        </div>
    </van-popup>
    <StatusPopup ref="statusPopupRef" :content="$t('collect.depositCollector')" />
</template>

<script setup lang="ts">
import StatusPopup from '@/components/common/statusPopup.vue'
import { ref, defineExpose, nextTick, onUnmounted, onMounted, watch } from 'vue'
const show = ref(false)
const statusPopupRef = ref()

const open = () => {
    show.value = true
}
const close = () => {
    show.value = false
}
const handleClick = () => {
    statusPopupRef.value.open()
}

defineExpose({
    open,
    close
})

</script>
<style scoped>
.popupContainer {
    background: transparent;
    display: flex;
    justify-content: center;
    width: 70%;
    height: 60%;
    z-index: 10002;
}

.collect_Container {
    position: relative;
}

.collect_Container img {
    width: 100%;
}

.scrollable-content {
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}

.card_list {
    padding: 30px 25px;
}

.van-popup::-webkit-scrollbar {
    display: none;
}

.point_star img {
    width: 12px;
}

.row_section {
    position: absolute;
    top: 40%;
}

.point_text {
    color: #000000;
    font-size: 15px;
    padding-top: 10px;
}

.point_star {
    padding-left: 25px;
    padding-top: 10px;
}

.close_button img {
    width: 20px;
}

.close_button {
    display: flex;
    justify-content: center;
}
</style>